import { ContentBlock, ContentState } from 'draft-js'
import { Map } from 'immutable'
import { BehaviorSubject } from 'rxjs'
import { CompositeEditorSubject } from '~/reactapp/DraftEditor/editor/types'
import { ANS } from '~/reactapp/story/ans/types'

export interface BlockData {
  ans: ANS
}

export interface BlockRendererProps {
  block: ContentBlock
  blockProps: {
    blockData: BlockData
    onStartEdit: (blockKey: string) => void
    onFinishEdit: (blockKey: string) => void
    setBlockData: (
      blockKey: string,
      blockData: Map<string, BlockData>,
      replace?: boolean
    ) => void
    compositeEditorSubject?: BehaviorSubject<CompositeEditorSubject>
    evictActiveInlineEditor?: () => void
    isFocused: boolean
  }
  contentState: ContentState
  children: Node
  className?: string
}

export interface WithAnsState {
  ans: ANS
}

export type WithAnsEnhancer = WithAnsState & {
  setAns: (ans: ANS) => void
}

export interface WithEditingEnhancer {
  isEditing: boolean
  setIsEditing: (isEditing: boolean) => void
  releaseEditing: () => void
  updateAnsData: (ans: ANS, replace?: boolean) => void
}

export interface WithSubmitHandler {
  submitValues: (
    editingDone?: boolean,
    skipSetIsEditing?: boolean,
    data?: unknown
  ) => void
}

export interface WithCancelHandler {
  cancel: () => void
}

export interface WithSyncStateProvided<T> {
  syncState?: (state: T) => T
}

export interface WithOnSetIsEditingProvided {
  onSetIsEditing?: (params: CompositeEditorSubject) => void
}

export interface WithBeforeUpdateProvided {
  beforeUpdate?: (ans: ANS) => boolean | undefined
}

export interface WithIsNewProvided {
  isNew?: boolean
}
